import { useTranslation } from "react-i18next";
import { getCookie } from "typescript-cookie";
import { message, Modal } from "antd";
import {
  useAddTheNeedsOfThePopulationMutation,
  useDeleteTheNeedsOfThePopulationMutation,
  useEditTheNeedsOfThePopulationMutation
} from "../../../../redux/api/organic/theNeedsOfThePopulationApi";
import { EntTheNeedsOfThePopulation } from "../../../../models/organic/theNeedsOfThePopulation";

const useTheNeedsOfThePopulation = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation();
  const { confirm } = modal;
  const [addTheNeedsOfThePopulation] = useAddTheNeedsOfThePopulationMutation();
  const [deleteTheNeedsOfThePopulation] = useDeleteTheNeedsOfThePopulationMutation();
  const [editTheNeedsOfThePopulation] = useEditTheNeedsOfThePopulationMutation();

  async function onAddTheNeedsOfThePopulation(newTheNeedsOfThePopulation: EntTheNeedsOfThePopulation): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addTheNeedsOfThePopulation(newTheNeedsOfThePopulation).then((response: any) => {
		if (response.error) {
		  const isKyrgyz = getCookie('i18next') === 'ky';
		  const lang = isKyrgyz ? 'kg' : 'ru';
		  const res = response.error.data?.res;
		  const errorMessages = Array.isArray(res)
			? res.map((error: any) => error[lang] || error.ru).join('\n')
			: response.error.data?.msg || t('unknownError');
		  throw new Error(errorMessages);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }


  async function onDeleteTheNeedsOfThePopulation(theNeedsOfThePopulation: EntTheNeedsOfThePopulation) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteTheNeedsOfThePopulation(theNeedsOfThePopulation.id as number).then((response: any) => {
			if (response.error !== undefined && response.error.status === 400) {
			  status = false;
			  throw new Error(`${ response.error.data.res.kg } / ${ response.error.data.res.ru }`);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({ title: t('msg.successDelete') });
			  if (refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onEditTheNeedsOfThePopulation(editedTheNeedsOfThePopulation: EntTheNeedsOfThePopulation): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editTheNeedsOfThePopulation(editedTheNeedsOfThePopulation).then((response: any) => {
		if (response.error !== undefined && response.error.status === 400) {
		  throw new Error(`${ response.error.data.res.kg } / ${ response.error.data.res.ru }`);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({ title: t('msg.successEdited') });
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  };

  return { onAddTheNeedsOfThePopulation, onDeleteTheNeedsOfThePopulation, onEditTheNeedsOfThePopulation };

}

export { useTheNeedsOfThePopulation };

